import React, { useReducer, createContext } from 'react'
import { colors } from '../styles/vars/colors.style'
import { forceTrailingSlash } from '../utils/utils'

export const StoreState = createContext()
export const StoreDispatch = createContext()

const initialState = {
  scroll: null,
  showTransitionMask: true,
  mobileNavIsOpen: false,
  modalIsOpen: false,
  pathname:
    typeof window === 'undefined'
      ? null
      : forceTrailingSlash(window.location.pathname.split('?')[0]),
  popstate: 0,
  waiting: true,
  countryCookie: null,
  maskColor: colors.darkBlue,
  expeditionCardIndex: null,
  headerDark: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_SCROLL': {
      return {
        ...state,
        scroll: action.payload,
      }
    }

    case 'SET_EXPEDITION_CARD_INDEX': {
      return {
        ...state,
        expeditionCardIndex: action.payload,
      }
    }

    case 'SET_HEADER_DARK': {
      return {
        ...state,
        headerDark: true,
      }
    }

    case 'SET_HEADER_LIGHT': {
      return {
        ...state,
        headerDark: false,
      }
    }

    case 'SET_MASK_COLOR': {
      return {
        ...state,
        maskColor: action.payload,
      }
    }

    case 'UPDATE_PATHNAME': {
      return {
        ...state,
        pathname: action.payload,
      }
    }

    case 'UPDATE_POP_STATE': {
      return {
        ...state,
        popstate: state.popstate + 1,
      }
    }

    case 'UPDATE_COUNTRY_COOKIE': {
      return {
        ...state,
        countryCookie: action.payload,
      }
    }

    case 'SHOW_TRANSITION_MASK': {
      return {
        ...state,
        showTransitionMask: true,
      }
    }
    case 'HIDE_TRANSITION_MASK': {
      return {
        ...state,
        showTransitionMask: false,
      }
    }

    case 'BEGIN_INITIAL_WAIT': {
      return {
        ...state,
        waiting: true,
      }
    }

    case 'END_INITIAL_WAIT': {
      return {
        ...state,
        waiting: false,
      }
    }

    case 'SHOW_MOBILE_NAV': {
      return {
        ...state,
        mobileNavIsOpen: true,
      }
    }
    case 'HIDE_MOBILE_NAV': {
      return {
        ...state,
        mobileNavIsOpen: false,
      }
    }
    case 'TOGGLE_MOBILE_NAV': {
      return {
        ...state,
        mobileNavIsOpen: !state.mobileNavIsOpen,
      }
    }

    case 'SHOW_MODAL': {
      return {
        ...state,
        modalIsOpen: true,
      }
    }
    case 'HIDE_MODAL': {
      return {
        ...state,
        modalIsOpen: false,
      }
    }

    default:
      throw new Error('Bad action type')
  }
}

const Store = props => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <StoreState.Provider value={state}>
      <StoreDispatch.Provider value={dispatch}>
        {props.children}
      </StoreDispatch.Provider>
    </StoreState.Provider>
  )
}

export default Store
